import { ModulesTypes } from "constants/features"
import { reduceModuleToPrivateRoute } from "./utils"
import { LanguageDictionary } from "../../constants/language"

export interface Submodule {
	component: React.ComponentType<any>
	module: ModulesTypes
	path: string
	policies?: string[]
	isNewModule?: boolean
	startDate?: Date
	endDate?: Date
	languages?: LanguageDictionary
}

export interface Module {
	component?: React.ComponentType<any>
	module: ModulesTypes
	path?: string
	policies?: string[]
	submodules?: Array<Submodule>
	languages?: LanguageDictionary
}
export interface ModuleAdapted {
	component?: React.ComponentType<any>
	module: ModulesTypes
	path?: string
	policies?: string[]
	submodule?: ModulesTypes
	isNewModule?: boolean
	startDate?: Date
	endDate?: Date
	languages?: LanguageDictionary
}

export const getModules = () => {
	const ConfigurationModule = require("./ConfigurationModule").default as Module
	const TransactionalModule = require("./TransactionalModule").default as Module
	const CustomerBehaviorModule = require("./CustomerBehaviorModule").default
	const UserManagementModule = require("./UserManagementModules")
		.default as Module

	return [
		TransactionalModule,
		CustomerBehaviorModule,
		UserManagementModule,
		ConfigurationModule,
	].reduce(reduceModuleToPrivateRoute, []) as Array<ModuleAdapted>
}

export default getModules
